<template>
  <div class="rr-reviews-display-images rr-reviews-display-images-container">
    <ul class="rr-reviews-display-images rr-reviews-display-images-img-container">
      <li
        v-for="(source, index) in sources"
        :key="index"
        class="rr-reviews-display-images rr-reviews-display-images-img-thumbnail"
      >
        <img
          role="button"
          tabindex="0"
          aria-haspopup="dialog"
          :aria-label="viewUserUploadedImageAccessibleLabel"
          :src="source"
          :width="config.imageSize"
          :height="config.imageSize"
          loading="lazy"
          alt=""
          @keydown.space.prevent
          @keyup.space="$emit('modal-open', index)"
          @keydown.enter="$emit('modal-open', index)"
          @click="$emit('modal-open', index)"
        />
        <button
          v-if="canDelete"
          type="button"
          class="btn-close"
          aria-label="remove"
          @click="$emit('remove-image', index)"
        >
          x
        </button>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'rfp-ratings-list-images',
  inject: ['viewUserUploadedImageAccessibleLabel'],
  props: {
    config: {
      type: Object,
      required: false,
      default() {
        return {
          imageSize: 80,
        };
      },
    },
    sources: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
    canDelete: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>
